var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrint2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 13C6 12.4477 6.44772 12 7 12H17C17.5523 12 18 12.4477 18 13V20C18 20.5523 17.5523 21 17 21H7C6.44772 21 6 20.5523 6 20V13ZM8 14V19H16V14H8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11C2 9.89543 2.89543 9 4 9H20C21.1046 9 22 9.89543 22 11V14C22 16.2091 20.2091 18 18 18H17C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16H18C19.1046 16 20 15.1046 20 14V11H4V14C4 15.1046 4.89543 16 6 16H7C7.55228 16 8 16.4477 8 17C8 17.5523 7.55228 18 7 18H6C3.79086 18 2 16.2091 2 14V11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4C6 3.44772 6.44772 3 7 3H17C17.5523 3 18 3.44772 18 4V7C18 7.55228 17.5523 8 17 8C16.4477 8 16 7.55228 16 7V5H8V7C8 7.55228 7.55228 8 7 8C6.44772 8 6 7.55228 6 7V4Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint2);
export default __webpack_public_path__ + "static/media/print_2.dec7755239ab579fd4f44a9b0cc2fb30.svg";
export { ForwardRef as ReactComponent };